import _ from 'lodash';

import { getEnvVar } from './env';
import { getDomainUrl } from './qs';

const appURL = getDomainUrl();
const adminURL = getEnvVar('REACT_APP_ADMIN_APP_URL');
const adminLogoutURL = `${adminURL}/logout.aspx`;

const clearChildrenWindows = (currentWindow = window) => (currentWindow.childrenWindows = []);

export const initChildrenWindows = () => {
  if (!Array.isArray(window.childrenWindows)) {
    clearChildrenWindows(window);
  }
};

const closeWindow = (currentWindow) => {
  currentWindow.close();
  currentWindow = null;
};

const closeOpener = () => {
  window.location = `${appURL}/logout`;
  window.focus();
};

const currentWindowLogout = (currentWindow) => {
  currentWindow.location = adminLogoutURL;
};

const close = (window) => {
  if (!_.isNil(window)) {
    closeWindow(window);
  }
};

const closeChildWindow = (value) => close(currentWindowLogout(value));

const getChildrenWindows = (windowObj) => windowObj.childrenWindows || [];

const hasChildren = (windowObj) => getChildrenWindows(windowObj).length > 0;

export const appendChildWindow = (childWindow) => {
  getChildrenWindows(window).push(childWindow);
};

export const closePrevChildrenWindows = () => {
  const children = getChildrenWindows(window);
  children.forEach(closeChildWindow);
  clearChildrenWindows();
};

const closeChildrenWindows = (currentWindow = window) => {
  const childrenWindows = getChildrenWindows(currentWindow);

  childrenWindows.forEach((childWindow) => {
    try {
      hasChildren(childWindow) ? closeChildrenWindows(childWindow) : close(childWindow);
    } catch (err) {
      childWindow.location = adminLogoutURL;
    }
  });
};

window.logout = (shoulCloseOpener = true) => {
  try {
    closeChildrenWindows(window);

    if (window.opener) {
      window.opener.logout();
      close(window);
    } else if (shoulCloseOpener) {
      closeOpener();
    }
  } catch (err) {
    if (shoulCloseOpener) {
      closeOpener();
    }
  }
};

export const getPagePathname = () => {
  const pathname = window.location.pathname;
  return pathname.substring(pathname.lastIndexOf('/'));
};
